import hop from "../assets/images/Hop.gif";

function Loading() {
    return(
        <div className="loading">
            <div className="block">
                <div className="container">
                    <div className="fixed-bottom">
                        <div className="cloud">
                        <div className="cloud cloud_second"></div>
                        </div>
                    </div>
                    <h1 className="title">Your notes</h1>
                    <img className="hop" src={hop} alt="hop" />
                    <div className="skeleton"></div>
                    <div className="skeleton"></div>
                    <div className="skeleton"></div>
                    <div className="skeleton"></div>
                    <div className="skeleton"></div>
                    <div className="skeleton"></div>
                </div>
            </div>
        </div>
    );
}

export default Loading;